export class TranslationsDto {
  [key: string]: string;
}
